<template>
    <modal class="cancelReserveModel" :isShow="visible">
        <div class="header">请选择退订原因
            <i class="iconfont icon-guanbi" @click="hide()"></i>
        </div>
        <div class="modal-body">
            <div class="tr-box" :class="{selected:reasonData?.OperateReason_AutoID==item.OperateReason_AutoID}" @click="reasonData=item"
                v-for="item in reasonList" :key="item">
                <span class="reason-radio"></span>
                <span class="reason-text">{{item.OperateReason_Name}}</span>
            </div>
            <div class="input-box" :class="{show:reasonData && reasonData.OperateReason_AutoID=='0'}">
                <textarea v-model="remarkText" :placeholder="placeholder" maxlength="50"></textarea>
                <div class="word-count">{{remarkText.length}}/50</div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>
// 备注输入弹层（退订原因）
export default {
    name: 'cancelReserveModel',
    data() {
        return {
            visible: false,
            placeholder: '请输入原因',
            //原因数据
            reasonList:[],
            reasonData:null,
            //原因
            remarkText: '',
            callback: null,
        }
    },
    mounted() {
        this.reasonList.push({
            OperateReason_Name:"其它",
            OperateReason_AutoID:"0"
        })
        this.$nextTick(() => {
            this.loadData();
        });
    },
    methods: {
        /**打开弹层，外部调用 */
        open() {
            this.visible = true;
            this.reasonData=null;
            this.remarkText="";
            this.loadData(true);
        },
        //加载退订原因
        loadData(isBo){
            if(this._load || this.reasonList?.length>1){
                return;
            }
            this._load=true;
            let loading;
            if(isBo){
                loading = this.$loading({
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
            const param={
                OperateKind:3//1:赠送原因， 2：折扣原因， 3：取消预定原因
            }
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetOperateReason", param).then(d => {
                this._load=false;
                if(isBo){
                    loading.close();
                }
                if (d.ResponseHeader.ResultCode != 0) {
                    if(isBo){
                        this.$message.error(d.ResponseHeader.ResultDesc);
                    }
                } else {
                    this.reasonList=d.ResponseBody||[];
                    this.reasonList.push({
                        OperateReason_Name:"其它",
                        OperateReason_AutoID:"0"
                    })
                    
                }
            }).catch(e => {
                if(isBo){
                    loading.close();
                    this.$message.error(e.message);
                }
                this._load=false;
                console.log('请求失败:', e);
            });
        },
        /**设置回调，外部调用 */
        cllBack(callback) {
            this.callback = callback;
        },
        hide() {
            this.visible = false;
        },
        confirm() {
            if (this.callback) {
                if(!this.reasonData){
                    this.$message.warning("请先选择退订原因");
                    return false;
                }
                let reasonText=this.reasonData?.OperateReason_Name;
                if(this.reasonData.OperateReason_AutoID==0){
                    reasonText=this.remarkText;
                }

                const result = this.callback(reasonText);
                if (result !== false) {
                    this.hide();
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './cancelReserveModel.scss'
</style>
